import { Table } from "dexie";

interface Options {
  optional?: true;
}

export function assertExists<T>(id: string, table: Table<T>): Promise<T>;
export function assertExists<T>(
  id: string | null,
  table: Table<T>,
  options: { optional: true },
): Promise<T | null>;
export async function assertExists<T>(
  id: string | null,
  table: Table<T>,
  options: Options = {},
): Promise<T | null> {
  if (id === null && options.optional) {
    return null;
  }
  const exists = await table.get(id);
  if (!exists) {
    throw new Error(`Record with id ${id} does not exist in table ${table.name}`);
  }
  return exists;
}
